<template lang="html">
  <div class="setup">
    <v-form ref="form">
      <v-select
        :items="digitItems"
        label="Számjegyek száma"
        v-model="setupData.digits"
      ></v-select>
      <v-select
        v-model="setupData.steps"
        label="Hány számmal dolgoznál?"
        :items="stepItems"
       ></v-select>
       <v-combobox
         v-model="setupData.speed"
         label="Hány mp legyen a megoldásra?"
         :items="speedItems"
          :rules="[rules.speedRules,]"
        ></v-combobox>
        <v-select
          v-model="setupData.method"
          label="Mit szeretnél gyakorolni?"
          :items="methodItems"
         ></v-select>
      <v-btn class="primary mt-5" @click.prevent="setupFinished">Indít</v-btn>
    </v-form>

  </div>
</template>

<script>
export default {
  data(){
    return{
      setupData: {
        digits: 2,
        speed: 8,
        steps: 2,
        method: 'összeadás'
      },
      digitItems: [1,2,3,4,5],
      stepItems: [2,3,4,5,6,7,8,9,10],
      speedItems: [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
      methodItems: ['összeadás', 'kivonás', 'vegyes'],
      rules: {
        speedRules(v){
          return (v>2 && v<60) || "min 2 mp, max 60 mp"
        }
      }
    }
  },
  methods:{
    setupFinished(){
      if (this.$refs.form.validate()) {
        this.$store.dispatch("setParameters", this.setupData)
        this.$emit('practiceStarted')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-form{
    margin-top: 30px;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
}
</style>
